const enum LogLevel {
  Info,
  Warn,
  Error
}

export default LogLevel;
